@if (isInitialized) {
  <oe-flat-widget button [modalComponent]="modalComponent" [title]="component.alias"
    [icon]="{name: 'oe-evcs', color: 'normal'}">
    <oe-flat-widget-line [name]="'GENERAL.MODE'| translate"
    [channelAddress]="component.id + '/_PropertyMode'"></oe-flat-widget-line>
  </oe-flat-widget>
}